export default [
  {
    path: '/admin/stock-closes',
    name: 'stock-close',
    meta: { requiresAuth: true },
    component: () => import('@/pages/stock/stock-close/index.vue')
  }
]
